<template>
    <v-container grid-list-xs fluid>
        <v-card>
            <v-toolbar dense dark color="secondary">
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-toolbar-title>
                    Audit Logs
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-col cols="2">
                    <v-text-field
                        v-model="search"
                        hide-details
                        class="mb-2 mt-3"
                        outlined
                        dense
                        label="Search by Shift"
                        v-if="loadData"
                        v-on:keyup.enter="getShift()"
                    ></v-text-field>
                </v-col>
            </v-toolbar>
            <v-container grid-list-xs fluid v-if="!loadData">
                <v-row justify="center">
                    <v-col cols="5" style="padding: 0px;margin: 0px;">
                        <v-text-field
                            v-model="search"
                            hide-details
                            class="mb-2 mt-2"
                            outlined
                            dense
                            label="Search by Shift"
                            v-on:keyup.enter="getShift()"
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-container>
            <v-container grid-list-xs fluid v-else>
                <v-row>
                    <v-col cols="8" class="tbla">
                        <table>
                            <thead>
                                <tr>
                                    <th>Shift Detail</th>
                                    <th>Driver</th>
                                    <th>Truck</th>
                                    <th>Yard</th>
                                    <th>Trailer</th>
                                    <th>ReplacementUnit</th>
                                </tr>
                                <tr>
                                    <td>{{ result.ShiftDetail }}</td>
                                    <td>{{ result.Driver }}</td>
                                    <td>{{ result.Truck }}</td>
                                    <td>{{ result.Yard }}</td>
                                    <td>{{ result.Trailer }}</td>
                                    <td>{{ result.ReplacementUnit }}</td>
                                </tr>
                                <tr>
                                    <th>Logs</th>
                                    <th>Shift Start Time</th>
                                    <th>Log Start Time</th>
                                    <th>GPS Start Time</th>
                                    <th>GPS End Time</th>
                                    <th>Log End Time</th>
                                </tr>
                                <tr>
                                    <td>
                                        <v-icon
                                            color="primary"
                                            @click="getLogs(result.ShiftDetail)"
                                            >mdi-eye-circle</v-icon
                                        >
                                    </td>
                                    <td>{{ result.ShiftStartTime }}</td>
                                    <td>{{ result.LogStart }}</td>
                                    <td>{{ result.GPSShiftStart }}</td>
                                    <td>{{ result.GPSShiftEnd }}</td>
                                    <td>{{ result.LogEnd }}</td>
                                </tr>
                            </thead>
                        </table>
                    </v-col>
                    <v-col cols="4">
                        <v-textarea
                            v-model="result.GPSComments"
                            rows="3"
                            class="mt-1 mb-1"
                            outlined
                            label="GPSComments"
                            hide-details
                        >
                        </v-textarea>
                    </v-col>
                </v-row>
                <div class="header">
                    <div class="sumTabs tbla">
                        <table></table>
                    </div>
                    <div class="sumComt">
                        <table>
                            <thead>
                                <tr>
                                    <th></th>
                                </tr>
                            </thead>
                        </table>
                    </div>
                </div>
                <div class="tbla">
                    <v-simple-table dense>
                        <thead>
                            <th style="width: 4%">OrderID</th>
                            <th style="width: 4%">Order Status</th>
                            <th style="width: 2%">L1</th>
                            <th style="width: 2%">L2</th>
                            <th style="width: 13%">Terminal</th>
                            <th style="width: 13%">Station</th>
                            <th style="width: 4%">City</th>
                            <th style="width: 8%">ETA</th>
                            <th style="width: 8%">Run Out</th>
                            <th style="width: 4%">Goal Post</th>
                            <th style="width: 8%">Retain</th>
                            <th>Comments</th>
                        </thead>
                        <tbody v-for="(itm, i) in result['orders']" :key="i">
                            <tr :class="itm.tbFont">
                                <td>{{ itm.OrderID }}</td>
                                <td>{{ itm.OrderStatus }}</td>
                                <td>{{ itm.LoadNum }}</td>
                                <td>{{ itm.LoadNumOrd }}</td>
                                <td>{{ itm.terminal.TerminalName }}</td>
                                <td>{{ itm.station.Name }}</td>
                                <td>{{ itm.station.City }}</td>
                                <td>{{ itm.ETATime }}</td>
                                <td>{{ itm.ROTime }}</td>
                                <td>{{ itm.GoalPost }}</td>
                                <td>{{ itm.RTTime }}</td>
                                <td rowspan="3">{{ itm.GPSComments }}</td>
                            </tr>
                            <tr :class="itm.tbFont">
                                <td rowspan="2">
                                    <v-icon
                                        large
                                        color="primary"
                                        @click="getLogs(itm.OrderID)"
                                        >mdi-eye-circle</v-icon
                                    >
                                </td>
                                <td colspan="3">Terminal Start</td>
                                <td>{{ itm.TStart }}</td>
                                <td>Station Start</td>
                                <td colspan="2">{{ itm.StStart }}</td>
                                <td colspan="3">
                                    <v-icon color="red" v-if="itm.NoAllocation"
                                        >mdi-gas-station-off</v-icon
                                    >
                                </td>
                            </tr>
                            <tr :class="itm.tbFont">
                                <td colspan="3">Terminal End</td>
                                <td>{{ itm.TEnd }}</td>
                                <td>Station End</td>
                                <td colspan="2">{{ itm.StEnd }}</td>
                                <td colspan="3" class="text-right"></td>
                            </tr>
                            <tr>
                                <th
                                    colspan="5"
                                    style="background: #adbbcc;"
                                ></th>
                                <th></th>
                                <th class="text-center">Product</th>
                                <th class="text-center">Quantity</th>
                                <th class="text-center">DispatchedQuantity</th>
                                <th class="text-center">No Allocation</th>
                                <th></th>
                            </tr>
                            <tr
                                v-for="(it, idx) in itm['order_details']"
                                :key="idx"
                            >
                                <td
                                    colspan="5"
                                    style="background: #adbbcc;"
                                ></td>
                                <td
                                    style="background: #adbbcc;"
                                    class="text-right"
                                >
                                    <v-btn
                                        @click="getLogs(it.OrderProdID)"
                                        color="primary"
                                        icon
                                    >
                                        <v-icon>mdi-eye-circle</v-icon>
                                    </v-btn>
                                </td>
                                <td style="background: #adbbcc;">
                                    <v-icon
                                        v-if="it.hasCKDropped"
                                        color="success"
                                        >mdi-check-circle</v-icon
                                    >
                                    <v-icon v-else>mdi-close-circle</v-icon>
                                </td>
                                <td style="background: #adbbcc;">
                                    {{ it.Product }}
                                </td>
                                <td style="background: #adbbcc;">
                                    {{ it.Quantity }}
                                </td>
                                <td style="background: #adbbcc;">
                                    {{ it.DispatchedQuantity }}
                                </td>
                                <td style="background: #adbbcc;">
                                    <v-icon v-show="it.hasNoAllocation"
                                        >mdi-gas-station-off</v-icon
                                    >
                                </td>
                                <td style="background: #adbbcc;"></td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </div>
            </v-container>
        </v-card>
        <showLogs
            v-if="$store.state.audit.show"
            :data="data"
            :audit="propst"
            :report="false"
        ></showLogs>
    </v-container>
</template>
<script>
import axios from 'axios';
import showLogs from './../Modals/Dispatch/Tracking/showLogs.vue';
export default {
    components: {
        showLogs
    },
    data: function() {
        return {
            search: '',
            loadData: false,
            data: [],
            result: [],
            propst: []
        };
    },
    methods: {
        alertView: function(itm) {
            itm.view = true;
            alert('test');
        },
        getLogs: function(itm) {
            var params = {
                subject: itm
            };
            console.log(params);
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .post('/audits/logs', params)
                // eslint-disable-next-line no-unused-vars
                .then(async response => {
                    this.data = response.data;
                    await this.data.forEach(data => {
                        if (
                            data.properties != '{"old": [], "attributes": []}'
                        ) {
                            data.show = true;
                        } else {
                            data.show = false;
                        }
                    });
                    console.log(this.propst);
                    str.state.isLoading = false;
                    this.$store.state.audit.show = true;
                    console.log(response.data);
                })
                .catch(function(error) {
                    str.state.isLoading = false;
                    console.log(error);
                });
        },
        getShift: function() {
            var params = {
                ShiftDetail: this.search
            };
            console.log(params);
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .post('/audits/search/shift', params)
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    str.state.isLoading = false;
                    this.result = response.data;
                    var font = 'tbDarkFont';
                    this.result.orders.forEach(itm => {
                        itm.view = false;
                        itm.tbFont = font;
                    });
                    this.loadData = true;
                })
                .catch(function(error) {
                    str.state.isLoading = false;
                    console.log(error);
                });
        }
    }
};
</script>
